<template>
    <v-container v-if="show" id="widget-area--hero-zone" fluid>
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <!-- <p>Widget Area = "Hero Zone"</p>
                <p>An optional-per-page slot for stuff</p> -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Hero',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>
